import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const reportsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    memberReports: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.memberReports,
        method: "POST",
        body,
      }),
    }),
    bookingReports: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.bookingReports,
        method: "POST",
        body,
      }),
    }),
    cancellationReports: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.cancellationReports,
        method: "POST",
        body,
      }),
    }),

    exportMemberReports: builder.mutation<
      CommonResponse,
      { format: string; body: any }
    >({
      query: ({ format, body }) => ({
        url: `${END_POINTS.exportMemberReport}?format=${format}`,
        method: "POST",
        body,
      }),
    }),

    exportBookingReports: builder.mutation<
      CommonResponse,
      { format: string; body: any }
    >({
      query: ({ format, body }) => ({
        url: `${END_POINTS.exportBookingReport}?format=${format}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useMemberReportsMutation,
  useBookingReportsMutation,
  useCancellationReportsMutation,
  useExportMemberReportsMutation,
  useExportBookingReportsMutation,
} = reportsApi;
